import type { StateStorage } from 'zustand/middleware';

/**
 * localStorage adapter for zustand persist: tolerates read failures; on QuotaExceededError,
 * removes the key and retries once so a bloated/corrupt entry can be replaced with a small payload.
 */
export const zustandSafeLocalStorage: StateStorage = {
    getItem: (name) => {
        try {
            return localStorage.getItem(name);
        } catch {
            return null;
        }
    },
    setItem: (name, value) => {
        try {
            localStorage.setItem(name, value);
        } catch (e) {
            if (e instanceof DOMException && e.name === 'QuotaExceededError') {
                console.warn(
                    `[zustand persist] localStorage quota exceeded for "${name}"; clearing key and retrying once`
                );
                try {
                    localStorage.removeItem(name);
                    localStorage.setItem(name, value);
                } catch {
                    // In-memory state still works
                }
            }
        }
    },
    removeItem: (name) => {
        try {
            localStorage.removeItem(name);
        } catch {
            /* ignore */
        }
    },
};
